import { useEffect } from 'react';
import { ScheduleTreatment } from '../../../entities/ScheduleTreatment';
import ScheduleTreatmentEvents from './ScheduleTreatmentEvents';
import ScheduleTreatmentTable from './ScheduleTreatmentTable';
import { Title } from './styled';
import ScheduleTreatmentViewModel from './viewModel';
import { dynamicCustomEventTracking } from '../../../lib/gtm';
import { useLocation } from 'react-router-dom';

type ScheduleTreatmentViewProps = {
  scheduleTreatments: ScheduleTreatment[];
};

export default function ScheduleTreatmentView({ scheduleTreatments }: ScheduleTreatmentViewProps) {
  const location = useLocation();
  const { scheduleTreatment, days, setSelectedDay, selectedDay } = ScheduleTreatmentViewModel({
    scheduleTreatments
  });

  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace('#', '');
      const element = document.getElementById(hash);
      if (element) {
        dynamicCustomEventTracking.send({ dynamicEventName: 'calendario_de_tratamento_mc' });
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <div>
      <Title variant="subtitle1" id="calendario-de-tratamento">
        Calendário de tratamento
      </Title>
      <ScheduleTreatmentEvents days={days} setSelectedDay={setSelectedDay} selectedDay={selectedDay} />
      <ScheduleTreatmentTable scheduleTreatment={scheduleTreatment} />
    </div>
  );
}
